import React, { Component } from 'react';
import Immutable from 'immutable';
import Dfp from './Dfp';
import 'whatwg-fetch';

class ArticleSearch extends Component {
 
	 constructor(){
		  super();
		  this.state = {
			  list:Immutable.List([]),
			  totalResults:0,
              page:1,
              searchTxt:( document.querySelector('meta[name="searchTxt"]') ? document.querySelector('meta[name="searchTxt"]').content : false ),
			  loading:false,
			  nextPage:true,
			  articleColumn:1
		  }

          let page = document.querySelector('meta[name="page"]').content;

          this.dfpList = [];
		  this.dfpCount = 0;
		  this.pagePlacement = page == 'home' ? 'homepage' : 'channels'
		  this.getLatestArticles = this.getLatestArticles.bind(this);
          this.isScrolledIntoView = this.isScrolledIntoView.bind(this);
          this.isScrolledOutOfView = this.isScrolledOutOfView.bind(this);
          this.handleScroll = this.handleScroll.bind(this);
          this.onChange = this.onChange.bind(this);
          this.onSubmit = this.onSubmit.bind(this);
		  this.extractHostname = this.extractHostname.bind(this);
		  this.getChannelURL = this.getChannelURL.bind(this);
		  this.dfpUpdate = this.dfpUpdate.bind(this);
		  this.dfpReady = this.dfpReady.bind(this);
	}
	getLatestArticles() {
        const {page, loading, searchTxt, nextPage, articleColumn} = this.state;
        const {author, catId, section, apiLabel, baseurl} = this.props;

        let that = this;
        // Google Custom Search Engine ID
        let cx = 'partner-pub-2533019376160003:cfjy5h-86nu';

        if(!loading && searchTxt){
            that.setState({
                loading: true
            })

            fetch('https://www.googleapis.com/customsearch/v1?q='+this.state.searchTxt+'&cx='+cx+'&num=10&start='+((this.state.page-1)*10+1)+'&key=AIzaSyCih1IgiZrkQT8hNOmGVM8g4JPywMXGk4Y',{
                method:"GET",
            }).then(function(res){
                return res.json();
            })
            .then(function(response) {
                let arr = [];

                if(response.queries.request[0].totalResults > 0){

                    arr = response.items;

                    arr.forEach(function (item) {
                        item.ad_post = false;
                        item.search_post = true;
                    });

                    that.setState({
                        list: that.state.list.concat(Immutable.List(arr)),
                        page: that.state.page + 1,
                        totalResults: response.queries.request[0].totalResults,
                        loading: false
                    });

                    if (document.querySelector('.btn-loadmore')) {
                        document.querySelector('.btn-loadmore').className = document.querySelector('.btn-loadmore').className + ' load';
                    }

                    if (document.getElementById('loading-bar')) {
                        document.getElementById('loading-bar').className = 'done';
                    }

                    // if (!response.next) {
                    //     if (document.querySelector('.btn-loadmore')) {
                    //         document.querySelector('.btn-loadmore').style.display = 'none';
                    //     }
                    // }

                    if (dataLayer && that.state.page > 1) {
                        let tmpPageURL = window.location.href;
                        dataLayer.push({
                            virtualPageTitle: document.title + ' (LoadMore)',
                            virtualPageURL: tmpPageURL.replace(/^.*\/\/[^\/]+/, ''),
                            event: 'VirtualPageview'
                        });
                    }

                    if (window.splashAd && document.getElementById('ad_splash-frame') && document.getElementById('ad_splash-frame').style.display == 'none')
                        googletag.pubads().refresh([window.splashAd]);

                    // that.setState({nextPage: response.next})

                }

            })

        }else{

        }
	}
	
	componentDidMount(){
		this.getLatestArticles();
		window.addEventListener('scroll', this.handleScroll);
	}
	
	componentWillUnmount(){
		window.removeEventListener('scroll', this.handleScroll);
	}

    dfpUpdate(){
        this.dfpCount++;
    }

    dfpReady(adunit){
        this.dfpList.push(adunit)

		if(this.dfpCount == this.dfpList.length){
            googletag.pubads().refresh(this.dfpList);
            this.dfpCount = 0;
            this.dfpList = [];
		}
	}
	
	isScrolledIntoView(elm,scrolltop){
		if(typeof elm == 'undefined') return;
        let docViewTop = scrolltop;
        let docViewBottom = docViewTop + ( window.outerHeight==0 ? window.innerHeight : window.outerHeight );

        let elemTop = elm.getBoundingClientRect().top+docViewTop;
        let elemBottom = elemTop + elm.getBoundingClientRect().height;

        

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    isScrolledOutOfView(elm,scrolltop){
        if(typeof elm == 'undefined') return;
        let docViewTop = scrolltop;
        let docViewBottom = docViewTop + ( window.outerHeight==0 ? window.innerHeight : window.outerHeight );

        let elemTop = elm.getBoundingClientRect().top+docViewTop;
        let elemBottom = elemTop + elm.getBoundingClientRect().height;

        return (elm.getBoundingClientRect().top <= docViewTop);
    }

	handleScroll(evnt){
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		if(this.isScrolledIntoView(document.querySelectorAll('.block-article-loadmore')[0],scrollTop)){
			if(document.querySelector('.btn-loadmore')){
                document.querySelector('.btn-loadmore').className = document.querySelector('.btn-loadmore').className+' load';
			}
            // googletag.pubads().refresh(['she.com_' + 'channels' + '_' + 'BTF_set' +'2'+'_300x250']);
            // let adunit = {};
            // adunit['slot1'] = googletag.defineSlot('she.com_' + 'channels' + '_' + 'BTF_set' +'2'+'_300x250', [[300, 250], 'ad_300x250']).addService(googletag.pubads());
            // adunit['slot2'] = googletag.defineSlot('she.com_' + 'channels' + '_' + 'BTF_set' +'2'+'_300x250', [[300, 250], 'ad_300x250']).addService(googletag.pubads());
            // googletag.pubads().refresh(adunit);
            this.getLatestArticles();
		}

        if(this.isScrolledOutOfView(document.querySelectorAll('#ad_300x250')[0],scrollTop)){
            if(document.querySelector('#side-panel')){
            	if(document.querySelector('#side-panel').className.indexOf("fixed") == -1){
                    document.querySelector('#side-panel').className = 'fixed';
                }
            }
            // this.getLatestArticles();
        }else{
            if(document.querySelector('#side-panel')){
                if(document.querySelector('#side-panel').className.indexOf("fixed") > -1){
                    document.querySelector('#side-panel').className = "";
                }
            }
		}

	}

    onChange(event) {
        this.setState({searchTxt: event.target.value});
    }

    onSubmit() {
        window.location.href = '?s='+this.state.searchTxt;
    }


    extractHostname(url) {
        var hostname;
        //find & remove protocol (http, ftp, etc.) and get hostname

        if (url.indexOf("://") > -1) {
            hostname = url.split('/')[2];
        }
        else {
            hostname = url.split('/')[0];
        }

        //find & remove port number
        hostname = hostname.split(':')[0];
        //find & remove "?"
        hostname = hostname.split('?')[0];

        return hostname;
    }

    getChannelURL(label, url){
		let tmpURL = '';

		if(label!='she-mom' &&  label!='she-brides' && label!='kChannel' && label != 'luxshery'){
            tmpURL = '/'+label
		}else{
			tmpURL = ( url.indexOf('https://') == -1 ? 'http://' : 'https://' ) + this.extractHostname(url)
		}

		return tmpURL
	}
	
	compileURL( name, url ) {
		if (!url) url = location.href
		name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
		let regexS = "[\\?&]"+name+"=([^&#]*)";
		let regex = new RegExp( regexS );
		let results = regex.exec( url );
		return results == null ? null : results[1];
	}
	
	
	renderGrid(item,index){
		const { theme, catId, subcat } = this.props;
		let tmp
		let tmpGTMLabel = 'H';
		let that = this;
		let extraIcon = ''
		
		if(catId!=0){
			if(subcat==0){
				tmpGTMLabel = 'C'
			}else{
				tmpGTMLabel = 'SC'
			}
		}

        if(item.search_post){
            item.format=item.pagemap.metatags[0]['article:format'];
		}
		if(item.format=='video'){
            extraIcon = <div className="extra-icon">
						<i className="icon-play-01"></i>
					  </div>
		}
		if(item.format=='promote'){
            extraIcon = <div className="extra-icon">
						<i className="icon-gift"></i>
					  </div>
		}

		tmp = <div className="grid-article-search">
			<a href={item.link} target={"_blank"} onClick={ () => that.linkInteractions(item.link,tmpGTMLabel+'/List')}>
				<div className="thumb-img-cell" style={{ backgroundImage:'url('+item.pagemap.metatags[0]['og:image']+')' }}></div>
			</a>
			<div className="desc-grid-article-search Abel">
				{extraIcon}
				<a href={item.link} target={"_blank"} onClick={ () => that.linkInteractions(item.link,tmpGTMLabel+'/List')}>
                    <h2 className="grid-article-title-search"  dangerouslySetInnerHTML={{ __html:item.htmlTitle }}></h2>
                    <div className="url">{decodeURI(item.link)}</div>
                    <p dangerouslySetInnerHTML={{ __html:item.htmlSnippet.replace("\u003cbr\u003e\n", "") }}></p>
				</a>
				<div className="clearfix">
					<ol className="info-list">
						<li><a href={this.getChannelURL(item.pagemap.metatags[0]['article:section'] , item.link)} target={"_blank"} style={{ color:item.pagemap.metatags[0]['article:section_color'] }} dangerouslySetInnerHTML={{ __html:item.pagemap.metatags[0]['article:section'] }}></a></li>
					</ol>
				</div>                
			</div>
		</div>

		return tmp
	}
		
	linkInteractions(url,type){
            if(dataLayer)
                dataLayer.push({event: 'linksection', virtualPageURL: url, linkSection: type});
	}
	
	 render() {
		 const { list, searchTxt, articleColumn, page } = this.state;
		 const { section, catId } = this.props;
		 let that = this;

         let loadBtn = '';

		loadBtn = <div className="grid-article-content grid-article-content-loadmore">
             <div className="block-article-loadmore" onClick={this.getLatestArticles}>
                 <div className="btn btn-loadmore text-center Abel">
                     <div className="btn-loadmore-over"></div>
                     <div className="btn-loading">
                         <span className="modal-pulsate" id="modal-bit-loader"></span>
                     </div>
                     <span>load more<i className="icon-arr_down-01"></i></span>
                 </div>
             </div>
         </div>;


         return(
            <div>
                <div className="article-search-bar">
                    <form>
                        <div className="inner-form">
                            <div className="input-field">
                                <div className="choices" data-type="text" aria-haspopup="true" aria-expanded="false"
                                     dir="ltr">
                                    <div className="choices__inner">
                                        <input
                                            className="form-control choices__input is-hidden"
                                            name="s"
                                            id="choices-text-preset-values" type="text"
                                            placeholder="To search, type and hit enter."
                                            tabIndex="-1" aria-hidden="true" data-choice="active"
                                            onChange={this.onChange}
                                            value={that.state.searchTxt}/>
                                    </div>
                                    <div className="choices__list choices__list--dropdown" aria-expanded="false">
                                    </div>
                                </div>
                                <button className="btn-search" type="button" onClick={this.onSubmit}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path
                                            d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="search-result Abel">about {that.state.totalResults} search results</div>
                {(list.size) ?
                            list.map(function(item,index){
                            // tmpArr.push(item);

                            return (
                                <div key={index/(articleColumn+1)} className="full-width clearfix">
                                    <div className="grid-article-content-search">
                                        <div key={index} className="grid-article-list-search">
                                            {that.renderGrid(item,index)}
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    : ''}
                {(that.state.totalResults > (that.state.page - 1) * 10 ) ? loadBtn : ''}
            </div>
         )
	 }
}

export default ArticleSearch;


// WEBPACK FOOTER //
// ./src/ArticleSearch.js